const fbConfig = process.env.REACT_APP_FIREBASE_CONFIG;
const apiUrl = process.env.REACT_APP_API_URL;

export default { fbConfig, apiUrl }
